<template>
  <div>
    <div class="yakukyari1st_jobsearch yakukyari1st_companies_jobsearch">
      <form id="yakukyari_1st-jobsearch" :action="path" :ref="'form'" accept-charset="UTF-8" method="post" class="yakukyari_1st-jobsearch">
        <input type="hidden" name="first_internship_search_condition[prefecture_ids]" v-model="prefectures">
        <input type="hidden" name="first_internship_search_condition[business_types]" v-model="businessTypes">
        <input type="hidden" name="first_internship_search_condition[months]" v-model="months">
        <input type="hidden" name="first_internship_search_condition[hold_days]" v-model="holdDays">
        <input type="hidden" name="first_internship_search_condition[is_online]" v-model="isOnline">
        <input type="hidden" name="first_internship_search_condition[is_facing]" v-model="isFacing">
        <input type="hidden" name="first_internship_search_condition[features]" v-model="features">
        <input type="hidden" name="first_internship_search_condition[hold_as_needed]" v-model="holdAsNeeded">
        <input type="hidden" name="first_internship_search_condition[work_contents]" v-model="workContents">

        <div class="section-companies">
          <div class="search-contents search-contents_keyword">
            <input v-model="keyword" type="text" placeholder=" 企業名 気になるキーワードなど" id="form_office_search_form_text" name="first_internship_search_condition[keyword]" class="use_lookup-icon">
            <button type="submit" class="link_btn_green"></button>
          </div>

          <div class="search-sp-flex">
            <div v-on:click.stop="showAreaModal()" class="search-contents search-contents_area">
              <p class="tit-icon"><img src="@assets/images/icon/img_search_icon_a.png" alt="エリア"></p>
              <a>
                <p v-if="prefectures.length" class="search-txt_example hopen">{{ prefecturesStore.getText() }}</p>
                <p v-else class="search-txt_example">希望エリア</p>
              </a>
            </div>

            <div v-on:click.stop="showAdditionalModal('search_modal_top')" class="search-contents search-contents_business">
              <p class="tit-icon tit_gyosyu"><img src="@assets/images/icon/img_search_icon_b.png" alt="業種"></p>
              <a>
                <p v-if="businessTypes.length" class="search-txt_example hopen">{{ businessTypesStore.getText() }}</p>
                <p v-else class="search-txt_example">希望業種</p>
              </a>
            </div>
          </div>
        </div>

        <div v-if="currentModal" class="sub_search_wrap sub_search_heightMax" id="search_modal_top">
          <AreaComponent v-if="isAreaModalShow" @close="closeModal" />
          <AdditionalConditionComponent v-if="isAdditionalModalShow" :scrollIntoView="scrollIntoView" @close="closeModal" />
          <div class="sub_search_wrap-modal-black-background"></div>
        </div>
      </form>
    </div>

    <!-- 重要ラベル -->
    <div class="yakukyari1st_jobsearch_companies_candidatelist">
      <ul>
        <li :class="['narrow_down', { 'is_active' : additionalConditionsStore.isActive.value }]">
          <a v-on:click.stop="showAdditionalModal('search_modal_top')">
            <span class="i_narrow_down">
              <img src="@assets/images/icon/i_narrow_down02.svg" alt="詳細検索">
            </span>
            <span class="i_narrow_down_active">
              <img src="@assets/images/icon/i_narrow_down_active02.svg" alt="詳細検索">
            </span>
          </a>
        </li>
        <li :class="{ 'is_active' : additionalConditionsStore.isActiveHoldDays.value }">
          <a v-on:click.stop="showAdditionalModal('detailedsearch_tit_hold_days')">
            開催日数
          </a>
        </li>
        <li :class="{ 'is_active' : additionalConditionsStore.isActiveRegions.value }">
          <a v-on:click.stop="showAdditionalModal('detailedsearch_tit_region')">
            開催形式
          </a>
        </li>
        <li :class="{ 'is_active' : additionalConditionsStore.isActiveFeatures.value }">
          <a v-on:click.stop="showAdditionalModal('detailedsearch_tit_feature')">
            特徴
          </a>
        </li>
        <li :class="{ 'is_active' : additionalConditionsStore.isActive.value }">
          <a v-on:click.stop="showAdditionalModal('search_modal_top')">
            詳細<span class="other_num">{{ additionalConditionsStore.isActive.value ? additionalConditionsStore.size : '' }}</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- /重要ラベル -->
  </div>
</template>

<script setup>
import { ref, provide, computed } from 'vue'
import AreaComponent from './components/area'
import AdditionalConditionComponent from './components/additional_condition'
import { getAreas, getPrefectures, getBusinessTypes, getMonths, getHoldDays, getFeatures, getWorkContents } from '@component_path/search-contents/internship/store/formOptions'

/* composables */
import { useAreas } from '@component_path/composables/areas.js'
import { usePrefectures } from '@component_path/composables/prefectures.js'
import { useBusinessTypes } from '@component_path/composables/businessTypes.js'
import { useMonths } from '@component_path/composables/months.js'
import { useHoldDays } from '@component_path/composables/holdDays.js'
import { useIsOnline } from '@component_path/composables/isOnline.js'
import { useIsFacing } from '@component_path/composables/isFacing.js'
import { useInternshipFeatures } from '@component_path/composables/internshipFeatures.js'
import { useHoldAsNeeded } from '@component_path/composables/holdAsNeeded.js'
import { useWorkContents } from '@component_path/composables/workContents.js'
import { useInternshipAdditionalConditions } from '@component_path/composables/internshipAdditionalConditions.js'
import { useKeyword } from '@component_path/composables/keyword.js'

const props = defineProps({
  formValues: { type: Object, required: true },
  path: { type: String, required: true }
})

/* store */
const prefecturesStore = usePrefectures(props.formValues.prefectures, getPrefectures())
const areasStore = useAreas(prefecturesStore, props.formValues.areas, getAreas(), props.formValues.clearAreas)
const businessTypesStore = useBusinessTypes(props.formValues.businessTypes, getBusinessTypes())
const monthsStore = useMonths(props.formValues.months, getMonths())
const holdDaysStore = useHoldDays(props.formValues.holdDays, getHoldDays())
const isOnlineStore = useIsOnline(props.formValues.isOnline)
const isFacingStore = useIsFacing(props.formValues.isFacing)
const featuresStore = useInternshipFeatures(props.formValues.features, getFeatures())
const holdAsNeededStore = useHoldAsNeeded(props.formValues.holdAsNeeded)
const workContentsStore = useWorkContents(props.formValues.workContents, getWorkContents())
const additionalConditionsStore = useInternshipAdditionalConditions(businessTypesStore, monthsStore, holdDaysStore, isOnlineStore, isFacingStore, featuresStore, holdAsNeededStore, workContentsStore)
const keywordStore = useKeyword(props.formValues.keyword)
provide('areasStore', areasStore)
provide('businessTypesStore', businessTypesStore)
provide('monthsStore', monthsStore)
provide('holdDaysStore', holdDaysStore)
provide('isOnlineStore', isOnlineStore)
provide('isFacingStore', isFacingStore)
provide('featuresStore', featuresStore)
provide('holdAsNeededStore', holdAsNeededStore)
provide('workContentsStore', workContentsStore)
provide('additionalConditionsStore', additionalConditionsStore)
provide('keywordStore', keywordStore)

/* data */
const currentModal = ref(null)
// 選択された重要ラベルがファーストビューで見えるようにモーダル内をスクロールする(デフォルトはモーダルの先頭)
const additionalModalFirstViewID = ref('search_modal_top')

/* methods */
const scrollIntoView = () => { document.getElementById(additionalModalFirstViewID.value).scrollIntoView() } // 選択された重要ラベルがファーストビューで見えるようにモーダル内をスクロールする
const closeModal = () => { currentModal.value = null }
const showAreaModal = () => { currentModal.value = 'area-modal' }
const showAdditionalModal = (first_view_id) => {
  additionalModalFirstViewID.value = first_view_id
  currentModal.value = 'additional-modal'
}

/* computed */
const prefectures = computed(() => prefecturesStore.prefectures.value)
const businessTypes = computed(() => businessTypesStore.businessTypes.value)
const months = computed(() => monthsStore.months.value)
const holdDays = computed(() => holdDaysStore.holdDays.value)
const isOnline = computed(() => isOnlineStore.isOnline.value)
const isFacing = computed(() => isFacingStore.isFacing.value)
const features = computed(() => featuresStore.features.value)
const holdAsNeeded = computed(() => holdAsNeededStore.holdAsNeeded.value)
const workContents = computed(() => workContentsStore.workContents.value)
const keyword = computed({
  get: () => keywordStore.keyword.value,
  set: (value) => keywordStore.set(value)
})
 // エリアモーダルが表示されているか?
const isAreaModalShow = computed(() => currentModal.value === 'area-modal')
// 詳細検索モーダルが表示されているか?
const isAdditionalModalShow = computed(() => currentModal.value === 'additional-modal')
</script>
